"use strict";

const ScrollDetectionPort = {
  add: function (app) {
    if (app.ports.setupScrollDetection) {
      app.ports.setupScrollDetection.subscribe(({ containerId }) => {
        // Find the visible container (not hidden by CSS)
        const allContainers = document.querySelectorAll(`#${containerId}`);
        let targetContainer = null;

        for (let container of allContainers) {
          const style = getComputedStyle(container);
          if (style.display !== "none" && style.visibility !== "hidden" && container.offsetParent !== null) {
            targetContainer = container;
            break;
          }
        }

        if (targetContainer) {
          targetContainer.removeEventListener("scroll", handleScroll);
          targetContainer.addEventListener("scroll", handleScroll, { passive: true });
        } else {
          console.warn(`Container with id "${containerId}" not found when trying to setup scroll detection`);
        }
      });
    }

    const handleScroll = (event) => {
      const container = event.target;
      const containerId = container.id;
      const scrollInfo = {
        containerId: containerId,
        x: container.scrollLeft,
        y: container.scrollTop,
        scrollHeight: container.scrollHeight,
        clientHeight: container.clientHeight,
      };
      app.ports.onScroll.send(scrollInfo);
    };
  },
};

module.exports = ScrollDetectionPort;
